var DayWeatherLandscapeComponent = /** @class */ (function () {
    function DayWeatherLandscapeComponent() {
        this.shortTemperatureFormat = false;
    }
    return DayWeatherLandscapeComponent;
}());
export { DayWeatherLandscapeComponent };
